import * as actionsTypes from "./actionTypes";

const searchEntityInterfaces = (entityId, searchFields) => ({
    type: actionsTypes.ENTITY_INTERFACE_SEARCH_REQUEST,
    entityId,
    searchFields
});

const getEntityInterfaceData = (entityId, entityInterfaceId) => ({
    type: actionsTypes.GET_ENTITY_INTERFACE_REQUEST,
    entityId,
    entityInterfaceId
});

const createEntityInterface = (interfaceId, entityInterfaceData) => ({
    type: actionsTypes.CREATE_ENTITY_INTERFACE_REQUEST,
    interfaceId,
    entityInterfaceData
});

const editEntityInterface = (entityId, entityInterfaceId, entityInterfaceData) => ({
    type: actionsTypes.EDIT_ENTITY_INTERFACE_REQUEST,
    entityId,
    entityInterfaceId,
    entityInterfaceData
});

const deleteEntityInterface = (entityId,  entityInterfaceId) => ({
    type: actionsTypes.DELETE_ENTITY_INTERFACE_REQUEST,
    entityId,
    entityInterfaceId
});

const resetEntityInterfaceForm = () => ({
    type: actionsTypes.RESET_ENTITY_INTERFACE_FORM
});

export default {
    searchEntityInterfaces,
    getEntityInterfaceData,
    createEntityInterface,
    editEntityInterface,
    deleteEntityInterface,
    resetEntityInterfaceForm
}